<template>
  <Core class="pc" :trendsList="useStickySearchData().top8Trending" :categoryList="useStickySearchData().categoryList"
    :sticky="props.sticky" :offset="props.offset" :showTag="props.showTag"></Core>

  <Core class="h5 sticky" :trendsList="useStickySearchData().top8Trending"
    :categoryList="useStickySearchData().categoryList" :sticky="props.sticky" :offset="props.offset"
    :showTag="props.showTag"></Core>
</template>

<script setup>
import { useStickySearchData } from '~/composables/useStickySearchData';
import Core from './core.vue';

const router = useRouter()
const route = useRoute()
const { $analytic } = useNuxtApp();
const localePath = useLocalePath()
const { t, locale } = useI18n();

// const { sticky, offset, showTag, trends } 
const props = defineProps({
  sticky: {
    required: false,
    default: true,
  },
  offset: {
    required: false,
    default: 40,
  },
  showTag: {
    required: false,
    default: true,
  },
  trends: {
    default: null
  }
});

const categoryList = ref([])
const categoryQuery = {
  language: locale.value === 'en' ? undefined : locale.value,
}

onMounted(async () => {
  // useStickySearchData().fetchTop8Trending().then((data) => {
  //   console.log(data)
  // })
  // useStickySearchData().fetchTop8Trending().then((data) => {
  //   console.log(data)
  // })
  // useStickySearchData().fetchTop8Trending().then((data) => {
  //   console.log(data)
  // })

  // useStickySearchData().fetchCategoryList().then((data) => {
  //   console.log(data)
  // })
  // useStickySearchData().fetchCategoryList().then((data) => {
  //   console.log(data)
  // })
  // useStickySearchData().fetchCategoryList().then((data) => {
  //   console.log(data)
  // })
  // if (props.trends) {
  //   const trendsQuery = {
  //     pageNum: 1,
  //     pageSize: 8,
  //     keyWords: '',
  //     language: locale.value
  //   }
  //   try {
  //     const _trendsData = await useGetTrendsList(trendsQuery, {
  //       client: true
  //     })
  //     trendsList.value = _trendsData.data
  //   } catch (error) {
  //     //
  //   }
  // }
})
</script>

<style lang="scss" scoped></style>
